import { useState } from "react";
import { toast } from "react-toastify";
import { useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import axios from "axios";
import BASE_URL from "../constants/baseUrls";

const useCaptcha = selectedFlight => {
    //general variables
    const [captcha, setCaptcha] = useState({ departure: null, return: null });
    const [_, setSearchParams] = useSearchParams();
    const { t } = useTranslation();
    const accessToken = localStorage.getItem("accessToken");

    const fetchCaptcha = async (flight, key) => {
        try {
            const response = await axios.get(`${BASE_URL}/api/v2/reserve/order/`, {
                params: {
                    departure: flight.departure,
                    destination: flight.destination,
                    departure_date: flight.departure_date,
                    departure_time: flight.departure_time,
                    flight_number: flight.flight_number,
                    id: flight.id,
                    class: flight.class,
                    sellingType: flight.sellingType,
                    airline: flight.airline,
                },
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            setCaptcha(values => ({ ...values, [key]: response?.data?.data }));
        } catch (error) {
            handleError(error);
        }
    };

    const handleError = error => {
        if (error.response.status === 401) {
            localStorage.clear();
            setSearchParams({ action: "login" });
        } else {
            toast.error(t("errorMessage"), {
                toastId: "custom-id-yes",
            });
        }
    };

    const getCaptcha = async () => {
        if (selectedFlight?.tag === "zm" && !selectedFlight?.return_segments?.length) {
            await fetchCaptcha(selectedFlight, "departure");
        }
        if (selectedFlight?.tag === "zm" && !!selectedFlight?.return_segments?.length) {
            await fetchCaptcha(selectedFlight, "return");
        }
    };

    return { captcha, getCaptcha };
};

export default useCaptcha;
